export default __webpack_public_path__ + "static/media/banner_1_ipad.3c3813c9.png";